import { DEFAULT_LAYOUT } from '@/router/constant'
import type { RouteRecordRaw } from 'vue-router'

const RecipientMaster: RouteRecordRaw = {
  path: '/RecipientMaster',
  name: 'RecipientMaster',
  component: DEFAULT_LAYOUT,
  redirect: '/RecipientMaster/indexView',

  children: [
    {
      path: 'indexView',
      name: 'RecipientMasterIndexView',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/recipientMaster/indexView.vue'
        ),
      meta: { title: '送信先マスタ', requiresAuth: false },
    },
  ],
}

export default RecipientMaster
